/**
 * Defesa contra `javascript:`, `data:`, `vbscript:` em href/src vindos
 * de payloads que poderiam (hoje ou no futuro) carregar URLs externas.
 *
 * Allowlist estrita: http(s) apenas. Qualquer scheme fora dessa lista
 * vira `#` (link inerte). URL inválida também cai pro mesmo placeholder.
 *
 * Compartilhado por componentes que renderizam metadata pré-fetched
 * (embed cards, modal de detalhe). Onde estiver duplicado localmente,
 * preferir esta versão.
 */
export function safeHref(url) {
  if (!url) return '#';
  try {
    const u = new URL(url, location.origin);
    if (u.protocol !== 'https:' && u.protocol !== 'http:') return '#';
    return u.href;
  } catch {
    return '#';
  }
}
flarum.reg.add('ramon-marketplace', 'common/utils/safeHref', { safeHref: safeHref, });